import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'neo-zona-fan',
  templateUrl: './zona-fan.component.html',
  styleUrls: ['./zona-fan.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ZonaFanComponent implements OnInit {
  precargarZfTitulo;
  precargarZfHistoria
  precargarZfComplejo;
  precargaMeta;
  zf_tit = 'zf-tit';

  historia_sub = 'historia-sub';
  historia_sub1 = 'historia-sub1';
  historia_txt1 = 'historia-txt1';
  historia_sub2 = 'historia-sub2';
  historia_txt2 = 'historia-txt2';
  historia_sub3 = 'historia-sub3';
  historia_txt3 = 'historia-txt3';
  historia_sub4 = 'historia-sub4';
  historia_txt4 = 'historia-txt4';
  historia_pie = 'historia-pie';
  historia_img = 'historia-img';

  complejo_tit = 'complejo-tit';
  complejo_img1 = 'complejo-img1';
  complejo_sub1 = 'complejo-sub1';
  complejo_txt1 = 'complejo-txt1';
  complejo_sub2 = 'complejo-sub2';
  complejo_txt2 = 'complejo-txt2';
  complejo_img2 = 'complejo-img2';
  complejo_img3 = 'complejo-img3';
  complejo_sub3 = 'complejo-sub3';
  complejo_txt3 = 'complejo-txt3';
  complejo_sub4 = 'complejo-sub4';
  complejo_txt4 = 'complejo-txt4';
  complejo_img4 = 'complejo-img4';
  complejo_img5 = 'complejo-img5';
  complejo_sub5 = 'complejo-sub5';
  complejo_txt5 = 'complejo-txt5';
  complejo_sub6 = 'complejo-sub6';
  complejo_txt6 = 'complejo-txt6';
  complejo_img6 = 'complejo-img6';
  complejo_img7 = 'complejo-img7';
  complejo_sub7 = 'complejo-sub7';
  complejo_txt7 = 'complejo-txt7';
  complejo_sub8 = 'complejo-sub8';
  complejo_txt8 = 'complejo-txt8';
  complejo_img8 = 'complejo-img8';
  complejo_img9 = 'complejo-img9';
  complejo_sub9 = 'complejo-sub9';
  complejo_txt9 = 'complejo-txt9';
  constructor(
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService,
    private route: ActivatedRoute,
    private configTitulo: ConfigTituloPaginasService
  ) {
    this.route.data.subscribe(
      response => {
        console.log('RESPONSE ZONA FAN', response);
        this.precargarZfTitulo = response.seccionesEditables.zf_titulo;
        this.precargarZfHistoria = response.seccionesEditables.zf_historia;
        this.precargarZfComplejo = response.seccionesEditables.zf_complejo;
        this.precargaMeta = response.seccionesEditables.precargaMeta;
      }
    );
  }

  ngOnInit(): void {
    this.iniciarPagina();
  }

  iniciarPagina(){
    if (this.helpersService.hayModulo('edicion')) {
      // **********************************
      // Titulo y meta
      // **********************************
      this.configTitulo.establecerTitulo('Zona fan', 'zf-meta', this.precargaMeta, 'meta-tit');
      this.configTitulo.establecerMeta(environment.descripcionMetaDefecto, 'zf-meta', this.precargaMeta, 'meta-des');
      // this.edicionSeccionesService.getContenidoBloquesSubseccion('zf-titulo').subscribe(data => {
      this.precargarZfTitulo.elementos.forEach((elemento, index) => {
        let indice = (this.precargarZfTitulo.multiple) ? index : -1;
        this.zf_tit = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'zf-tit', indice);
          return;
        })

      // })

      // this.edicionSeccionesService.getContenidoBloquesSubseccion('zf-historia').subscribe(data => {
      this.precargarZfHistoria.elementos.forEach((elemento, index) => {
        let indice = (this.precargarZfHistoria.multiple) ? index : -1;
          this.historia_sub = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-sub', indice);
          this.historia_sub1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-sub1', indice);
          this.historia_txt1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-txt1', indice);
          this.historia_sub2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-sub2', indice);
          this.historia_txt2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-txt2', indice);
          this.historia_sub3 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-sub3', indice);
          this.historia_txt3 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-txt3', indice);
          this.historia_sub4 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-sub4', indice);
          this.historia_txt4 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-txt4', indice);
          this.historia_pie = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-pie', indice);
          this.historia_img = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'historia-img', indice);
          return;
        })

      // })

      this.edicionSeccionesService.getContenidoBloquesSubseccion('zf-complejo').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;
          this.complejo_tit = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-tit', indice);
          this.complejo_img1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-img1', indice);
          this.complejo_sub1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-sub1', indice);
          this.complejo_txt1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-txt1', indice);
          this.complejo_sub2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-sub2', indice);
          this.complejo_txt2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-txt2', indice);
          this.complejo_img2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-img2', indice);
          this.complejo_img3 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-img3', indice);
          this.complejo_sub3 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-sub3', indice);
          this.complejo_txt3 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-txt3', indice);
          this.complejo_sub4 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-sub4', indice);
          this.complejo_txt4 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-txt4', indice);
          this.complejo_img4 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-img4', indice);
          this.complejo_img5 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-img5', indice);
          this.complejo_sub5 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-sub5', indice);
          this.complejo_txt5 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-txt5', indice);
          this.complejo_sub6 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-sub6', indice);
          this.complejo_txt6 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-txt6', indice);
          this.complejo_img6 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-img6', indice);
          this.complejo_img7 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-img7', indice);
          this.complejo_sub7 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-sub7', indice);
          this.complejo_txt7 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-txt7', indice);
          this.complejo_sub8 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-sub8', indice);
          this.complejo_txt8 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-txt8', indice);
          this.complejo_img8 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-img8', indice);
          this.complejo_sub9 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-sub9', indice);
          this.complejo_txt9 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-txt9', indice);
          this.complejo_img9 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'complejo-img9', indice);
          return;
        })

      })
    }
  }

}
